import CommonCarousel from '~/components/CommonCarousel/CommonCarousel';

import styles from './CarouselView.module.scss';
import type { CarouselViewProps } from './interfaces';

const CarouselView = ({ children }: CarouselViewProps) => {
  return (
    <div className={styles.root}>
      <CommonCarousel
        pagination={{
          enabled: true,
          className: styles.dots,
          clickable: true,
          bulletClassName: styles.paginationDot,
          activeBulletClassName: styles.paginationDotActive,
        }}
        sliderClassName={styles.slider}
        slideClassName={styles.slide}
        arrows={false}
        slidesPerGroup={5}
        spaceBetween={16}
      >
        {children}
      </CommonCarousel>
    </div>
  );
};

export default CarouselView;
